import { Component, OnInit, Inject, Injector } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { addressI } from 'app/core/interfaces/adress';
import { MaterialDialog } from 'app/modules/shared/components/dialog/dialog.component';
import { DialogData } from 'app/core/interfaces/dialog';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { telecom } from 'app/core/models/Patient';
import { PractitionerOrganizationAffiliationService } from 'app/core/http/services/practititoner-organization-affiliation.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RegisterHoursComponent } from 'app/modules/practitioner/components/register-hours/register-hours';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'page-organization-details',
  templateUrl: './organization-details.component.html',
  styleUrls: ['./organization-details.component.scss'],
})
export class PractitionerOrganizationDetailsComponent extends BaseComponent implements OnInit {
  public organization: any | undefined = <any>{};
  public address: addressI = <addressI>{};
  public titles = ['Qualificações', 'Cursos/Certificados', 'Idiomas'];
  public checked = true;
  public telecom: any = {};
  public location: any = {};
  public affiliations: any = {};
  public specialtys: any;
  public affiliationReference: any = '';
  public form: FormGroup;
  public specialtyForms: FormGroup[] = [];
  public refreshComponent: Boolean = true;
  public isSaving = false;
  public affiliationStatus: string = '';

  constructor(
    public dialogRef: MatDialogRef<MaterialDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private injector: Injector,
    private affiliationService: PractitionerOrganizationAffiliationService,
    private fb: FormBuilder
  ) {
    super(injector);
    this.form = this.fb.group({
      averageDuration: ['', Validators.required],
      byOrder: [false],
    });
  }

  ngOnInit(): void {
    this.getDetails();
  }

  getDetails() {
    if (this.data.param.location) {
      this.location = this.data.param?.location;
    }

    this.affiliations = this.data.param.affiliations;
    this.affiliationStatus = this.data.param.type;
    this.specialtys = this.getSpecialtys(this.data.param.type);

    this.specialtys.forEach((specialty: any) => {
      const form = this.fb.group({
        averageDuration: [specialty.averageDuration || '', Validators.required],
        byOrder: [specialty.byOrder || false],
      });

      this.specialtyForms.push(form);
    });
    this.getAffiliationDetails();
  }

  getSpecialtys(type: string) {
    return this.affiliations.specialty.filter((specialty: any) => specialty.status === type);
  }

  getSpecialtysSectionTitle(type: string) {
    if (type == 'requested') return 'Pendente Aprovação';

    if (type == 'accepted') return 'Confirmados';

    return 'Cancelados';
  }

  allowOnlyNumbers(event: KeyboardEvent): void {
    const inputChar = event.key;

    if (!/^\d$/.test(inputChar)) {
      event.preventDefault();
    }
  }

  getAffiliationDetails() {
    this.affiliationService.showByAffiliationId(this.affiliations.affiliation_id).subscribe({
      next: (resAffiliationDetails: any) => {
        this.affiliationReference = resAffiliationDetails;

        this.specialtys.forEach((specialty: any, index: number) => {

          const matched = this.affiliationReference.specialty.find(
            (item: any) =>
              item.display === specialty.display &&
              item.status === specialty.status
          );

          if (matched) {
            const averageDuration = matched.averageDuration || '';
            const byOrder = matched.byOrder || false;

            this.setValuesToFormGroup(index, averageDuration, byOrder);
          }
        });
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  setValuesToFormGroup(index: number, averageDuration: string, byOrder: boolean) {
    this.specialtyForms[index].patchValue({
      averageDuration: averageDuration,
      byOrder: byOrder,
    });
  }


  getCurrentDateTime() {
    const now = new Date();
    return now.toISOString();
  }

  cancelAffiliation(specialty: any) {
    const affiliationId = this.affiliationReference.affiliation_id;
    const updatedSpecialties = [...this.affiliationReference.specialty];

    const idx = updatedSpecialties.findIndex((s) => s.id === specialty.id);
    if (idx !== -1) {
      updatedSpecialties[idx] = {
        ...updatedSpecialties[idx],
        status: 'cancelled',
      };
    }

    const data = {
      ...this.affiliationReference,
      specialty: updatedSpecialties,
      updateDateTime: this.getCurrentDateTime(),
    };

    this.affiliationService.update(affiliationId, data).subscribe({
      next: (resUpdated: any) => {
        this.showErrorMessage = false;
        this.showSuccessMessage = true;
        this.specialtys = updatedSpecialties;
      },
      error: (err) => {
        console.log(err);
        this.showErrorMessage = true;
        this.showSuccessMessage = false;
      },
    });
  }

  saveAverageTime() {
    this.isSaving = true;

    const affiliationId = this.affiliationReference.affiliation_id;
    const updatedSpecialties = [...this.affiliationReference.specialty];

    this.specialtys.forEach((specialty: any, index: number) => {
      const targetSpecialtyIndex = updatedSpecialties.findIndex((s) => s.id === specialty.id
        && (specialty.status == "requested" || specialty.status == "accepted")
        && s.status == specialty.status

      );

      if (targetSpecialtyIndex !== -1) {
        updatedSpecialties[targetSpecialtyIndex] = {
          ...updatedSpecialties[targetSpecialtyIndex],
          averageDuration: this.specialtyForms[index].value.averageDuration,
          byOrder: this.specialtyForms[index].value.byOrder,
        };
      }
    });



    const data = {
      ...this.affiliationReference,
      specialty: updatedSpecialties,
      updateDateTime: this.getCurrentDateTime(),
    };

    this.affiliationService.update(affiliationId, data).subscribe({
      next: (resUpdated: any) => {
        this.showErrorMessage = false;
        this.showSuccessMessage = true;
        this.isSaving = false;
        this.affiliationReference = resUpdated;
      },
      error: (err: HttpErrorResponse) => {

        this.messageError = err.error.message
        this.showErrorMessage = true;
        this.showSuccessMessage = false;
        this.isSaving = false;
      },
    });
  }

  openChangeHoursDialog(specialty: any) {
    const data = {
      param: {
        affiliation: this.affiliations,
        specialtyChangeId: specialty.id,
      },
    };

    this.dialog.openComponentDialog(RegisterHoursComponent, data).subscribe({
      next: (res: any) => {
        this.getAffiliationDetails()
      }
    });
  }

  onPasteName(event: ClipboardEvent): void {
    const clipboardData = event.clipboardData?.getData('text') ?? '';
    const validPositiveIntegerRegex = /^[1-9]\d*$/;
    if (!validPositiveIntegerRegex.test(clipboardData)) {
      event.preventDefault();
    }
  }
}
